import * as LJS from "../../../lib/littlejs.esm";
import { tilesize } from '../../const/tiles.ts';
import Globals from "../../globals.ts";
/*
 * Actionables are objects you can encounter on the map and interact
 * with, such as levers, doors, etc.
 */
class Actionable extends LJS.EngineObject {
    constructor(pos, tileIndex) {
        super(pos, LJS.vec2(1, 1), LJS.tile(tileIndex, tilesize));
        // Overridden by the child class to make the actionable interactive
        this.key = "KeyE";
        this.state = "disabled";
        this.distance = 2;
        this.setCollision(false, false, false, false);
        this.mass = 0; // Not affected by gravity
    }
    // Default behavior : display a message when the user is near, and call the action if the key was pressed
    update() {
        const distance = this.pos.distance(Globals.player.pos);
        if (distance < this.distance) {
            this.message();
            if (LJS.keyWasReleased(this.key)) {
                this.action();
            }
        }
    }
    // Displays a message when we are near the actionable
    message() {
        LJS.drawTextOverlay("[E] Activate", LJS.vec2(this.pos.x, this.pos.y + 1), 0.5);
    }
    action() {
        console.log("Activated");
    }
}
export default Actionable;
